export function unshiftUnique<T>(ar: Array<T>, value: T): Array<T> {
  const b = ar.filter((e) => e !== value);
  b.unshift(value);
  return b;
}
